import React, { useState } from "react";
import styles from "./inventorySliderComponents.module.scss";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import SelectDateRange from "./SelectDateRange";
import DaySelectionWeekDays from "./DaySelectionWeekDays";
import DateRangePicker from "./DateRangePicker/DateRangePicker";

const InventoryUnblock = ({
  categories,
  baseUrl,
  property_id,
  userToken,
  permissions,
  fetchInfo,
  currentDate,
  setShow,
  room_id,
  viewType,
}) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [blockInventoryData, setBlockInventoryData] = useState({
    property_id: property_id,
    from_date: "",
    to_date: "",
  });

  // const blockInventoryDataUpdateHandle = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/v1/inventories/unblock/${property_id?.id}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${userToken}`,
  //         },
  //         body: JSON.stringify({
  //           ...blockInventoryData,
  //           room_categories: selectedValues,
  //         }),
  //       }
  //     );

  //     const data = await response.json();

  //     if (response.ok && data.success) {
  //       showSuccessToast(data.message);
  //       fetchInfo(property_id?.id, room_id, viewType);
  //       setShow(false);
  //     } else {
  //       showErrorToast(data.message || "An error occurred.");
  //       console.log("Post request failed with status:", response.status);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     showErrorToast("An error occurred while processing your request.");
  //   } finally {
  //   }
  // };

  const unBlockInventory = async (e) => {
    e.preventDefault();
    const headers = {
      "X-Channel-Token": "PoGC1kGsepDYT7lQ4Azqmmou03oqFbHA    mmm",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${userToken}`,
      "Cookie": process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      hotelCode: property_id,
      roomCode: selectedValues,
      type: "unblock",
      "from-date": blockInventoryData?.from_date,
      "to-date": blockInventoryData?.to_date
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v2/channel-manager/inventory/block`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow"
        }
      );

      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error("Error blocking inventory:", error);
    }
  };

  // const [inventoryData, setInventoryData] = useState([]);

  // const handleCheckboxChange = (event) => {
  //   const { value, checked } = event.target;

  //   if (checked) {
  //     if (!inventoryData.some((item) => item.room_id === parseInt(value))) {
  //       setInventoryData([
  //         ...inventoryData,
  //         { room_id: parseInt(value), available_rooms: "" },
  //       ]);
  //     }
  //   } else {
  //     // Remove the item from inventoryData if unchecked
  //     setInventoryData(
  //       inventoryData.filter((item) => item.room_id !== parseInt(value))
  //     );
  //   }
  // };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      // Check if the value is not already in the array before adding it
      if (!selectedValues.includes(value)) {
        setSelectedValues([...selectedValues, value]);
        addCheckbox();
      }
    } else {
      // Remove the value from the array if it exists
      setSelectedValues(selectedValues?.filter((item) => item !== value));
    }
  };

  const addCheckbox = () => {
    const newCheckbox = {
      id: Date.now(),
      label: `Option ${checkboxOptions.length + 1}`,
      value: `option${checkboxOptions.length + 1}`,
    };

    setCheckboxOptions([...checkboxOptions, newCheckbox]);
  };

  console.log(blockInventoryData, 'blockInventoryData');
  const [checkboxOptions, setCheckboxOptions] = useState([]);

  return (
    <div>
      <div className={styles.container}>
        <div style={{ width: "100%" }}>
          <div style={{ paddingBottom: "5px" }}>Select Date Range</div>
          {/* <SelectDateRange
            dataFromChild={(from_date, to_date) => {
              setBlockInventoryData({
                ...blockInventoryData,
                from_date: from_date,
                to_date: to_date,
              });
            }}
            minDate={new Date(currentDate)}
          /> */}

          <DateRangePicker
            size={"medium"}
            onChange={(from_date, to_date) =>
              setBlockInventoryData({
                ...blockInventoryData,
                from_date: from_date,
                to_date: to_date,
              })
            }
            // disabled={index === dateRanges.length - 1 ? false : true}
            minDate={new Date(currentDate)}
          />
        </div>

        <hr />
        {/* <div>
          <DaySelectionWeekDays onSaveDates={() => { }} />
        </div> */}
        <hr />
        <div className="form-container-div-half">
          <div className="form-container-div">
            <div
              style={{
                color: "#333",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              Select Room Categories
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                color: "#333",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "400",
                flexDirection: "column",
              }}
            >
              {categories?.map((room) => {
                return (
                  <div>
                    <input
                      type="checkbox"
                      name="update_type"
                      onChange={handleCheckboxChange}
                      value={room.roomId}
                      style={{ marginRight: "10px" }}
                    />
                    {room.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`flex align_items_center flex_gap_10 ${styles.buttonContainer}`}
      >
        {/* <BgThemeButton
          onClick={blockInventoryDataUpdateHandle}
          children={"Update"}
        />
       
        <Button onClick={() => setShow(false)}>Cancel</Button> */}

        <button
         disabled
          type="submit"
          style={{opacity: 0.5}}
          // className="vendor_common_property pointer"
          onClick={unBlockInventory}
        >Update
        </button>

        <button
          className="no_logout_btn"
          onClick={() => setShow(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default InventoryUnblock;
